/*=========================================================================================
  File Name: gettes.js
  Description: Menus Getters
  ----------------------------------------------------------------------------------------
  Item Name: Fujisushi Web app
  Author: Tan Tran
==========================================================================================*/
export default {
    productsByCategory : (state) => (category) => {
      // console.log('productsByCategory: ' + category);
      // let items = state.currentMenu.menuItems.filter(o => o.categoryName === category);
      // console.log(items)
      console.log(category)
      let products = state.currentMenu.menuItems.filter(o => o.categoryName === category);
      console.log(products);
      return products;
    },

    subProductsByProductId : (state) => (productId) => {
      return state.currentMenu.menuItems.filter(o => o.parentId === productId);
    },

    sortedCategories : (state) => {

      let orderedCategoryList = [
        'sashimi',
        'fuji-style maki',
        'kaburimaki',
        'futomaki',
        'uramaki',
        'pokebowls',
        'vegetar - retter',
        'godt og blandet'
      ];

      for (let index = 0; index < orderedCategoryList.length; index++) {
        let categoryIndex = state.currentMenu.menuCategories.findIndex(o => o.categoryName.toLowerCase() === orderedCategoryList[index].toLowerCase());

        if (categoryIndex > -1) {

          let category = state.currentMenu.menuCategories[categoryIndex];

          state.currentMenu.menuCategories.splice(categoryIndex, 1);

          state.currentMenu.menuCategories.unshift(category);
        }

      }

     
      return state.currentMenu.menuCategories;
    }
}